import { useEffect } from 'react';

import * as Meta from 'meta';
import { ROUTE } from "route";

export const EndPage = () => {
  useEffect(() => {
    document.getElementById('loading')?.remove();
    document.querySelector('[href="/resources/html/css/style.css"]')?.remove();
  }, []);
  return (
    <div>
      {Meta.loadCSS(['end'])}
      {Meta.ga("活動結束頁面")}
      <div id="layout">

        <a href={ROUTE.HOME}><img className="logo" src="/resources/html/images/preview/logo.svg" /></a>

        <div className="kv" />

        <div className="preview">
          <img className="btlt" src="/resources/html/images/preview/bottom_lt.png" />
          <img className="btrt" src="/resources/html/images/preview/bottom_rt.png" />
          <div className="intext">
            <h1>爽啤QRcode抽獎活動<br />已於 8/11 結束 謝謝參與！</h1>
          </div>
        </div>
        <div id="ft_atten"><img className="pc" src="/resources/html/images/preview/warn.png" /><img className="mb" src="/resources/html/images/preview/ft_atten_mb.jpg" /></div>
      </div>
    </div>
  );
};
